<template>
  <!--
    Visualização de um atendimento (#7286).

    Mesmo layout do Diário Online (EDrawerMotivoAula): drawer à direita, cabeçalho com o
    tipo do lançamento na cor da situação e os campos em sequência, terminando em
    Situação e Motivo.

    Os dados vêm da própria listagem, que já carrega horario, matricula.aluno e
    professor — não há chamada extra ao back, como no Diário Online.
  -->
  <v-navigation-drawer width="400" v-model="localDrawer" right temporary app>
    <v-list-item :class="atendimento.color">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">
          {{ atendimento.tipo_de_atendimento }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Aluno (a)</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ atendimento.nomeAluno }}
        </p>
        <v-divider></v-divider>

        <v-list-item-title class="mt-4">Professor (a)</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ atendimento.professor ? atendimento.professor.nome : "- - -" }}
        </p>

        <v-list-item-title class="mt-4">Data</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ atendimento.data_formatada }}
        </p>

        <v-list-item-title class="mt-4">Horário</v-list-item-title>
        <p class="font-weight-light text-justify">● {{ atendimento.descricaoHorario }}</p>

        <v-list-item-title class="mt-4">Bimestre</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ atendimento.bimestreDescricao }}
        </p>

        <div v-for="(rotulo, campo) of campos" :key="campo">
          <template v-if="atendimento[campo]">
            <v-list-item-title class="mt-4">{{ rotulo }}</v-list-item-title>
            <p class="font-weight-light text-justify">{{ atendimento[campo] }}</p>
          </template>
        </div>

        <v-list-item-title class="mt-4">Situação</v-list-item-title>
        <v-list-item-title>
          <v-chip label :color="atendimento.color">
            {{ atendimento.descricaoSituacao }}
          </v-chip>
        </v-list-item-title>

        <v-list-item-title class="mt-4">Motivo</v-list-item-title>
        <p class="font-weight-light">
          {{ atendimento.motivo ? atendimento.motivo : "Sem motivo." }}
        </p>
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "EDrawerVisualizarAtendimento",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    atendimento: {
      type: Object,
      required: true,
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  data() {
    return {
      localDrawer: this.value,
      // Campos de texto livre, exibidos só quando preenchidos. atividades_realizadas é
      // do apoio-pedagogico; nos demais perfis vem vazio e nem aparece.
      campos: {
        conteudo: "Conteúdo",
        metodologia: "Metodologia",
        atividades_realizadas: "Atividades realizadas",
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
